import { Injectable } from '@angular/core';
import notify from 'devextreme/ui/notify';
import moment from 'moment';
import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
import { AuthService } from '../shared/services';

pdfMake.vfs = pdfFonts.pdfMake.vfs;

@Injectable({
  providedIn: 'root',
})
export class PdfZaIspisPlanaNovoService {

  docDefinition: any = [];

  constructor(private authService: AuthService) {}

  pdfIspisPlanaNovo(data, planovi, sirovine, ambalaza) {
    console.log(data);
    //console.log(planovi);
    //console.log(sirovine);
    //console.log(ambalaza);
    let hLine = {
        table: {
          widths: ['*'],
          body: [[''], ['']],
        },
        layout: {
          hLineWidth: function (i, node) {
            return i === 0 || i === node.table.body.length ? 0 : 1;
          },
          vLineWidth: function (i, node) {
            return 0;
          },
        },
      };
  
      let ct = [];
      ct.push({
        text: 'Ispis plana proizvodnje i sirovina',
        style: 'mainTitle',
      });
      ct.push({
        text: [
          `Datum: ${moment(data.od).format('DD.MM.YYYY.')} - ${moment(
            data.do
          ).format('DD.MM.YYYY.')}
          Smjena: ${!data.s ? 'SVE' : data.s}
          Pogon: ${!data.p ? 'SVE' : data.nazivPogona}
          Linija: ${!data.l ? 'SVE' : data.nazivLinije}`,
        ],
        style: 'subtitle',
        margin: [0, 15, 0, 30],
      });
  
      ct.push({
        text: 'Proizvodi',
        style: 'subtitle',
        margin: [0, 0, 0, 5],
      });
      ct.push({
        table: {
          widths: [108, 40, 255, 40, 40],
          body: [
            [
              { text: 'Linija' },
              { text: 'Šifra' },
              { text: 'Proizvod' },
              { text: 'Smjena' },
              { text: 'Količina', alignment: 'right' },
            ],
          ],
        },
        layout: 'lightHorizontalLines',
      });
      ct.push(hLine);
      planovi.forEach((item) =>{
        ct.push(
          {
            stack:[
              { text: item.nazivLinije + ' - ', bold: true, style: 'header' },
            ],
          },
        );
        //zatrazena linija da mogu rucno upisati napomenu
        ct.push(hLine);
        for (let i = 0; i < item.proizvodArray.length; i++) {
          ct.push(
            { table: {
                widths: [115, 50, 260, 40, 50],
                body: [
                  [
                    { text: '' },
                    { text: item.proizvodArray[i].ar_sifra },
                    { text: item.proizvodArray[i].ar_naziv },
                    { text: item.proizvodArray[i].smjena_idsmjena, bold: true, alignment: 'center' },
                    { text: this.formatiraj(item.proizvodArray[i].ukupnakolicina, 2), alignment: 'right' },
                  ]
                ],
              },
              layout: 'noBorders',
            }
          );
        }
      });
      ct.push(hLine);
  
      ct.push({
        text: 'Sirovine',
        style: 'subtitle',
        margin: [0, 15, 0, 5],
      });
      ct.push({
        table: {
          widths: [108, 40, 220, 40, 40, 35],
          body: [
            [
              'Linija',
              'Šifra',
              'Stavka',
              'Smjena',
              { text: 'Količina', alignment: 'right' },
              'Jed.mj.',
            ],
          ],
        },
        layout: 'lightHorizontalLines',
      });
      ct.push(hLine);
      sirovine.forEach((item) =>{
        ct.push(
          {
            stack:[
              { text: item.nazivLinije, bold: true, style: 'header' },
            ],
          },
        );
        for (let i = 0; i < item.sirovinaArray.length; i++) {
          ct.push(
            { table: {
                widths: [115, 50, 225, 40, 50, 35],
                body: [
                  [
                    { text: '' },
                    { text: item.sirovinaArray[i].normativsifra },
                    { text: item.sirovinaArray[i].normativstavske },
                    { text: item.sirovinaArray[i].smjena_idsmjena, bold: true, alignment: 'center' },
                    { text: this.formatiraj(item.sirovinaArray[i].kolicinanormativ, 2), alignment: 'right' },
                    { text: item.sirovinaArray[i].jedinicamjere_JM_SIFRA, margin: [20, 0, 0, 0] },
                  ]
                ],
              },
              layout: 'noBorders',
            }
          );
        }
      }); 
      ct.push(hLine);
      
      ct.push({
        text: 'Ambalaža',
        style: 'subtitle',
        margin: [0, 15, 0, 5],
      });
      ct.push({
        table: {
          widths: [108, 40, 185, 35, 40, 70],
          body: [
            [
              'Linija',
              'Šifra',
              'Stavka',
              'Smjena',
              { text: 'Količina', alignment: 'right' },
              { text: 'Stanje skladista', alignment: 'right' },
            ],
          ],
        },
        layout: 'lightHorizontalLines',
      });
      ct.push(hLine);
      ambalaza.forEach((item) =>{
        ct.push(
          {
            stack:[
              { text: item.nazivLinije, bold: true, style: 'header' },
            ],
          },
        );
        for (let i = 0; i < item.ambalazaArray.length; i++) {
          ct.push(
            { table: {
                widths: [115, 50, 190, 40, 45, 75],
                body: [
                  [
                    { text: '' },
                    { text: item.ambalazaArray[i].artikl_ar_asifra_abbalaze },
                    { text: item.ambalazaArray[i].ar_naziv },
                    { text: item.ambalazaArray[i].smjena_idsmjena, bold: true, alignment: 'center' },
                    { text: this.formatiraj(item.ambalazaArray[i].ukupnoambalaza, 2), alignment: 'right' },
                    { text: this.formatiraj(item.ambalazaArray[i].skladisteambalaze, 2), alignment: 'right'},
                  ]
                ],
              },
              layout: 'noBorders',
            }
          );
        }
      });
      ct.push(hLine);
    
      //PRAZNI REDOVI IZMEĐU DIJELOVA PDF-a RADI IZGLEDA
      ct.push({
        columns: [
          {
            table: {
              widths: [500],
              body: [
                //PRAZAN RED
                [''],
              ],
            },
            layout: 'noBorders',
          },
        ],
      });
  
      ct.push({
        text: 'Dodatno',
        style: 'subtitle',
        margin: [0, 20, 0, 5],
      });
  
      //PRAZNI REDOVI IZMEĐU DIJELOVA PDF-a RADI IZGLEDA
      ct.push({
        columns: [
          {
            table: {
              widths: [500],
              body: [
                //PRAZAN RED
                [''],
              ],
            },
            layout: 'noBorders',
          },
        ],
      });
  
      ct.push({
        table: {
          widths: [500],
          body: [
            [{ text: 'Vezice:     _______________________', alignment: 'left' }],
          ],
        },
        layout: 'lightHorizontalLines',
      });
  
      //PRAZNI REDOVI IZMEĐU DIJELOVA PDF-a RADI IZGLEDA
      ct.push({
        columns: [
          {
            table: {
              widths: [500],
              body: [
                //PRAZAN RED
                [''],
                [''],
              ],
            },
            layout: 'noBorders',
          },
        ],
      });
  
      ct.push({
        table: {
          widths: [500],
          body: [
            [{ text: 'Strech:     _______________________', alignment: 'left' }],
          ],
        },
        layout: 'lightHorizontalLines',
      });
  
      //PRAZNI REDOVI IZMEĐU DIJELOVA PDF-a RADI IZGLEDA
      ct.push({
        columns: [
          {
            table: {
              widths: [500],
              body: [
                //PRAZAN RED
                [''],
                [''],
              ],
            },
            layout: 'noBorders',
          },
        ],
      });
  
      ct.push({
        table: {
          widths: [500],
          body: [
            [
              {
                text: 'Selotejp:     _______________________',
                alignment: 'left',
              },
            ],
          ],
        },
        layout: 'lightHorizontalLines',
      });
  
      //PRAZNI REDOVI IZMEĐU DIJELOVA PDF-a RADI IZGLEDA
      ct.push({
        columns: [
          {
            table: {
              widths: [500],
              body: [
                //PRAZAN RED
                [''],
                [''],
              ],
            },
            layout: 'noBorders',
          },
        ],
      });
  
      ct.push({
        table: {
          widths: [500],
          body: [
            [
              {
                text: 'Deklaracija:     _______________________',
                alignment: 'left',
              },
            ],
          ],
        },
        layout: 'lightHorizontalLines',
      });
  
      //PRAZNI REDOVI IZMEĐU DIJELOVA PDF-a RADI IZGLEDA
      ct.push({
        columns: [
          {
            table: {
              widths: [500],
              body: [
                //PRAZAN RED
                [''],
                [''],
              ],
            },
            layout: 'noBorders',
          },
        ],
      });
  
      ct.push({
        table: {
          widths: [500],
          body: [
            [
              {
                text: 'Paletna deklaracija:     _______________________',
                alignment: 'left',
              },
            ],
          ],
        },
        layout: 'lightHorizontalLines',
      });
      ct.push(hLine);
  
      this.docDefinition = {
        info: {
          title: `Datum: ${moment(data.od).format('DD.MM.YYYY.')} - ${moment(
            data.do
          ).format('DD.MM.YYYY.')}`,
        },
        content: ct,
        footer: function (currentPage: any, pageCount: any) {
          return {
            columns: [
              {
                text: `${moment().format('DD.MM.YYYY. HH:mm')}`,
                style: 'footer',
              },
              {
                text: `${currentPage.toString()}/${pageCount}`,
                style: 'footer',
                alignment: 'right',
              },
            ],
            margin: 15,
          };
        },
        pageMargins: [15, 15, 15, 35],
        defaultStyle: {
          fontSize: 9.5,
        },
        styles: {
          mainTitle: {
            fontSize: 17,
            bold: true,
          },
          subtitle: {
            fontSize: 13,
          },
          footer: {
            fontSize: 10,
            color: 'gray',
          },
        },
      };
      pdfMake.createPdf(this.docDefinition).open();
  }

  formatiraj(broj: any, dec_mj: any){
    return this.authService.formatiraj(broj, dec_mj);
  }
}